import { render, staticRenderFns } from "./ImageAssetDialog.vue?vue&type=template&id=8fe49540&scoped=true"
import script from "./ImageAssetDialog.vue?vue&type=script&lang=ts"
export * from "./ImageAssetDialog.vue?vue&type=script&lang=ts"
import style0 from "./ImageAssetDialog.vue?vue&type=style&index=0&id=8fe49540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe49540",
  null
  
)

export default component.exports